import { defineStore } from "pinia";

export const tableStateStore = (identifier: string) =>
  defineStore(`control/${identifier}`, {
    state: () => ({
      state: {} as ITableState,
      config: {} as ITableConfig,
      reload: true
    }),
  })(); // <- this is the key right here, by initialising it here

// export const controlStateStore = defineStore("controlState", {
//   state: () => ({
//      controls: new Map() as Map<string, IControlState>
// }),
//   actions: {
//     registerControlState(identifier:string,state : IControlState) {
//         this.controls.set(identifier,state);
//     },
//     patchControl(identifier:string,state:IControlState) {
//         this.controls.set(identifier,state);
//     }
//   },
// });
